import { getSettlement, postTaxPdf } from "crud/auth.crud";
import React, { Fragment ,useState, useEffect } from "react"
import MetaTags from 'react-meta-tags';

import { Link } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"

import weaverOverlay from "../../assets/images/weaver_overlay.png"
import moment from "moment";
import Util from "pages/Dashboard/Common/Util";
import Modal from "components/RopikCustom/Modal";
import Loading from "pages/Custom/Loading";

const SettlementDetails = (props) => {
  const {companyName, companyNumber, settlementDate, getListLength, searchState, paymentStatus} = props;
  const [dataList, setDataList] = useState([])
  const [modalShow, setModalShow] = useState(false)
  const [detailData, setDetailData] = useState()
  const [onUpload, setOnUpload] = useState(false);
  const [pdfUrl, setPdfUrl] = useState();

  const getDataList = async () => {    
    setOnUpload(true)

    const params = {
      company_name: companyName || '',
      company_number: companyNumber || '',
      settlement_date: settlementDate || '',
      state: paymentStatus
    }

    let url = '/summary_wearing/summary_wearing_list/?company_name=' + params.company_name + '&company_number=' + params.company_number + '&settlement_date=' + params.settlement_date + '&state=' + params.state;

    const response = await getSettlement(url);    
    if (response.status === 200) {
      const content = response.data?.data || [];
      if (content.length > 0) {
        setDataList([...content])
        getListLength(content.length || 0)
      } else {
        setDataList([])
      }
    }
    setOnUpload(false)
  }

  const modalClose = () => {
    setModalShow(false)
  }

  const clickList = async (item) => {
    setDetailData(item);
    setModalShow(true)
  }

  useEffect(() => {
    getDataList()
  }, [settlementDate, searchState, paymentStatus])

  return (
    <Row>
      <Col xs="12">
        <div className="email-rightbar mb-3">
          <Card>
            <CardBody style={{ padding: 0, borderRadius: 4, overflow: 'hidden' }}>
              <div className="table-responsive">
                <table id="excel-table" className="table table-hover table-centered table-nowrap mb-0 chart-table">
                  <thead className="chart-thead">
                    <tr>
                      <th scope="col">No</th>
                      <th scope="col">사업자 번호</th>
                      <th scope="col">처리장명</th>
                      <th scope="col">인계량(kg)</th>
                      <th scope="col">정산금액(원)</th>
                      <th scope="col">정산일자</th>
                      <th scope="col">납부여부</th>
                      <th scope="col">정산상세</th>
                    </tr>
                  </thead>
                  <tbody className="chart-tbody clickable">

                    {
                      dataList && dataList.map((item, index) => {
                        return (
                          <tr className="pointer" key={item.id + '_' + index}>
                            <td className="pointer" >{dataList.length - index}</td>
                            <td className="pointer" >{item.company.company_number}</td>
                            <td className="pointer" onClick={() => { clickList(item) }} >{item.company.name}</td>
                            <td className="pointer" >{Util.setCommaPrice(item.qty_kg)}</td>
                            <td className="pointer" >{Util.setCommaPrice(item.total_price)}</td>
                            <td className="pointer" >{moment(item.summary_date).format('YYYY-MM-DD')}</td>
                            <td className="pointer" style={{ color: item.state === 'Y' ? '#126782' : '#DA0000' }} >
                              {item.state === 'Y' ? '완납' : item.state === 'N' ? '미납' : '부분납부'}
                            </td>
                            <td>
                              <div className="btn-group waver-common-btn-group">
                                <button type="button" className="custom-btn border-radius-0 primary-bg white-text button-border margin-right-0" style={{ width: 114 }} onClick={(e) => {
                                  e.stopPropagation()
                                  setModalShow(true)
                                  setDetailData(item)
                                }}>
                                  정산상세
                                </button>
                              </div>
                            </td>
                          </tr>
                        )
                      })
                    }
                    {dataList.length === 0 &&
                      <tr>
                        <td scope="row" colSpan="8">데이터가 없습니다.</td>
                      </tr>
                    }

                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>
        </div>
      </Col>
      {onUpload && <Loading />}

      <Modal title={''} show={modalShow} onHide={modalClose} size="md"><div className="d-flex justify-content-center w-100">
        <div className="bill-mock-up">
          <div className="header">
            <p className="header-text">{moment(detailData?.summary_date).format('YYYY')+'년 '+moment(detailData?.summary_date).format('MM')+'월 정산내역 상세'}</p>
          </div>
          <div className="main-banner">
            <div className="text-container">
              <p className="banner-main-text">스마트<br /><span>수거 플랫폼</span></p>
              <p className="banner-sub-text">Smart Food Waste Collection Platform</p>
            </div>
            <img className="logo" src={weaverOverlay} />
          </div>
          <p className="company">{detailData?.company?.name}</p>
            <Fragment>
              <div className="charge-box margin-top-14">
                <div className="d-flex align-items-end">
                  <p className="charge">인계 현황</p>
                </div>
                <div className="charge-container">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="month-charge-text">인계량 / kg</p>
                    <div className="white-value-box">
                      <p className="box-text">{Util.setCommaPrice(detailData?.qty_kg)}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="charge-box margin-top-12">
                <div className="d-flex align-items-end">
                  <p className="charge">정산 금액</p>
                </div>
                <div className="charge-container">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="all-charge-text">고지금액</p>
                    <div className="white-value-box">
                      <p className="box-text all-charge-box-text">{Util.setCommaPrice(detailData?.total_price)}</p>
                    </div>
                  </div>
                  <p className="explanation">정산금액은 인계된 폐기물의 양을 기준으로 합니다.</p>
                </div>
                <div className="charge-container">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="month-charge-text">금월 청구금액</p>
                    <div className="white-value-box">
                      <p className="box-text">{Util.setCommaPrice(detailData?.price)}</p>
                    </div>
                  </div>
                </div>
                <div className="charge-container">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="unpaid-text">VAT</p>
                    <div className="white-value-box">
                      <p className="box-text">{Util.setCommaPrice(detailData?.vat)}</p>
                    </div>
                  </div>
                </div>
                <div className="charge-container">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="unpaid-text">납부금액</p>
                    <div className="white-value-box">
                      <p className="box-text">{Util.setCommaPrice(detailData?.payed_price)}</p>
                    </div>
                  </div>
                </div>
                <div className="charge-container">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="unpaid-text">미납금액</p>
                    <div className="white-value-box">
                      <p className="box-text">{Util.setCommaPrice(detailData?.total_price - detailData?.payed_price)}</p>
                    </div>
                  </div>
                </div>
                <div className="charge-container">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="unpaid-text">완납여부</p>
                    <div className="white-value-box">
                      <p className="box-text">{detailData?.state === 'Y' ? '완납' : detailData?.state === 'N' ? '미납' : '부분납부'}</p>
                    </div>
                  </div>
                </div>
                <div className="line line-1"></div>
                <div className="line line-2"></div>
              </div>
            </Fragment>       
        </div>
      </div>
      </Modal>
    </Row>
  )
}

export default SettlementDetails
